import { useState, useEffect, useRef } from 'react';
import confetti from 'canvas-confetti';

const getInitialTheme = () => {
  const stored = localStorage.getItem('theme');
  if (stored) return stored;
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
};

const Navbar = ({ onCmdOpen }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [theme, setTheme] = useState(getInitialTheme);
  const [eggVisible, setEggVisible] = useState(false);
  const clickCountRef = useRef(0);
  const eggTimerRef = useRef(null);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024) setMenuOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const scrollTo = (id, e) => {
    e && e.preventDefault();
    const el = document.getElementById(id);
    if (!el) return;
    window.scrollTo({ top: el.offsetTop - 64, behavior: 'smooth' });
    setMenuOpen(false);
  };

  const toggleTheme = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'));

  const handleLogoClick = (e) => {
    scrollTo('home', e);
    clickCountRef.current += 1;
    if (clickCountRef.current >= 5) {
      clickCountRef.current = 0;
      clearTimeout(eggTimerRef.current);
      confetti({
        particleCount: 160,
        spread: 100,
        origin: { x: 0.1, y: 0.05 },
        colors: ['#FF5C00', '#ff8c42', '#f0ede8', '#00c896', '#ffd700'],
      });
      setEggVisible(true);
      eggTimerRef.current = setTimeout(() => setEggVisible(false), 3200);
    }
  };

  return (
    <>
      <nav className="navbar">
        <button className="nav-logo" onClick={handleLogoClick}>
          JM<span className="dot">.</span>
        </button>

        <ul className="nav-links">
          <li><a href="#skills" onClick={(e) => scrollTo('skills', e)}>Skills</a></li>
          <li><a href="#experience" onClick={(e) => scrollTo('experience', e)}>Experience</a></li>
          <li><a href="#projects" onClick={(e) => scrollTo('projects', e)}>Projects</a></li>
          <li><a href="#resume" onClick={(e) => scrollTo('resume', e)}>Resume</a></li>
          <li>
            <a className="nav-cta" href="#contact" onClick={(e) => scrollTo('contact', e)}>
              Let's Connect
            </a>
          </li>
        </ul>

        <div className="nav-right">
          <button className="cmd-hint-btn" onClick={onCmdOpen} title="Open command palette (⌘K)">
            <span className="cmd-hint-key">⌘</span>K
          </button>
          <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
            {theme === 'dark' ? '☀' : '☽'}
          </button>
          <button className="nav-menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>

        <div className={`nav-mobile-menu${menuOpen ? ' open' : ''}`}>
          <a href="#skills" onClick={(e) => scrollTo('skills', e)}>Skills</a>
          <a href="#experience" onClick={(e) => scrollTo('experience', e)}>Experience</a>
          <a href="#projects" onClick={(e) => scrollTo('projects', e)}>Projects</a>
          <a href="#resume" onClick={(e) => scrollTo('resume', e)}>Resume</a>
          <a className="nav-mobile-cta" href="#contact" onClick={(e) => scrollTo('contact', e)}>
            Let's Connect
          </a>
        </div>
      </nav>

      {eggVisible && (
        <div className="easter-toast">
          🎉 You found the easter egg! Here's a cookie 🍪
        </div>
      )}
    </>
  );
};

export default Navbar;
